import { ActionTypes } from "../constants/actionTypes";

export const updateLoader = (data) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_LOADER,
      payload: data,
    });
  };
};
